import { render, staticRenderFns } from "./ProductsDataTable.vue?vue&type=template&id=756af0d2"
import script from "./ProductsDataTable.vue?vue&type=script&lang=ts"
export * from "./ProductsDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports